module.exports = __webpack_public_path__ + "img/vape-shop-custom-website-img-5.671bf0c6.webp";